import styled from '@emotion/styled';

export default styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;